import { render } from "./SupportLinks.vue?vue&type=template&id=2af3a6d6&scoped=true"
import script from "./SupportLinks.vue?vue&type=script&lang=js"
export * from "./SupportLinks.vue?vue&type=script&lang=js"

import "./SupportLinks.vue?vue&type=style&index=0&id=2af3a6d6&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2af3a6d6"]])

export default __exports__